import React from 'react';
import Error from './Error';
import LoadingMask from './LoadingMask';
import Spinner from './Spinner';
const SpinnerError = ({ error, loading, firstLoading, inline, children, title, }) => {
    if (error) {
        return <Error error={error} inline={inline}/>;
    }
    if ((firstLoading === undefined && loading) || firstLoading) {
        return <Spinner inline={inline} title={title}/>;
    }
    if (children && firstLoading === undefined) {
        return <>{children}</>;
    }
    else if (children) {
        return <LoadingMask active={loading}>{children}</LoadingMask>;
    }
    return null;
};
export default SpinnerError;
